<template>
  <mi-dialog
    :model-value="showModal"
    no-esc-dismiss
    no-backdrop-dismiss
    class="export-new-list-options-modal"
    :close-icon="false"
  >
    <div class="export-new-list-options-modal__header">
      <h3>EXPORT CONFIGURATIONS</h3>
    </div>
    <div class="export-new-list-options-modal__content">
      <span class="description q-mb-md">Select one or more configurations to export</span>
      <mi-checkbox
        class="export-option"
        :model-value="isYellowConfigurationSelected"
        color="accent"
        @click="toggleExportOption('yellow')"
      >
        Yellow Configuration
      </mi-checkbox>
      <mi-checkbox
        class="export-option"
        color="accent"
        :model-value="isGreenConfigurationSelected"
        @click="toggleExportOption('green')"
      >
        Green Configuration
      </mi-checkbox>
    </div>

    <template #actions>
      <mi-btn
        flat
        @click="closeModal"
      >
        Cancel
      </mi-btn>
      <mi-btn
        color="accent"
        :disable="!hasAtLeastOneOptionSelected"
        @click="onHandleExport"
      >
        Export
      </mi-btn>
    </template>
  </mi-dialog>
</template>

<script>
  import MiCheckbox from '@/packages/@mi-library/MiCheckbox/MiCheckbox.vue'
  import { computed, inject } from 'vue'
  import { SAVED_LISTS_EXPORT_OPTIONS_PROVIDER } from '@/components/pac/saved-lists/utils'

  export default {
    name: 'ExportListOptionsModal',
    components: { MiCheckbox },
    props: {
      showModal: {
        type: Boolean,
        default: false
      },
      listId: {
        type: String,
        default: '',
        required: true
      },
      onHandleExport: {
        type: Function,
        default: () => ({}),
        required: true
      }
    },
    emits: ['update:show-modal'],
    setup(props, { emit }) {
      const closeModal = () => {
        emit('update:show-modal', false)
      }

      const selectedOptions = inject(SAVED_LISTS_EXPORT_OPTIONS_PROVIDER)

      const toggleExportOption = option => {
        selectedOptions.value[option] = !selectedOptions.value[option]
      }

      const isYellowConfigurationSelected = computed(() => selectedOptions.value.yellow)
      const isGreenConfigurationSelected = computed(() => selectedOptions.value.green)

      const hasAtLeastOneOptionSelected = computed(() => Object.values(selectedOptions.value).some(Boolean))

      return {
        closeModal,
        isYellowConfigurationSelected,
        isGreenConfigurationSelected,
        toggleExportOption,
        hasAtLeastOneOptionSelected
      }
    }
  }
</script>

<style lang="scss">
  .export-new-list-options-modal {
    .q-dialog__inner > .mi-card {
      width: 466px;
      max-width: 466px;
      height: 280px;
    }

    &__header {
      h3 {
        margin: 0;
      }
    }

    &__content {
      padding-top: 8px;
      display: flex;
      flex-direction: column;

      .description {
        font-family: "Man Europe", sans-serif;
        font-weight: 400;
        font-size: 16px;
        line-height: 150%;
        letter-spacing: 0;
        vertical-align: middle;
        color: #303c49;
      }

      .export-option {
        margin-top: 18px;
        font-family: "Man Europe", sans-serif;
        font-weight: 400;
        font-size: 16px;
        line-height: 150%;
        letter-spacing: 0;
        vertical-align: middle;
      }

      .mi-card__actions {
        padding-top: 16px;
        padding-right: 24px;
      }
    }
  }
</style>
